module.exports = __webpack_public_path__ + "img/menu-back.0b7f5619.svg";